import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { Priority } from '@ui';

@Component({
  selector: 'ui-priority-indicator',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoDirective],
  template: `
    <ng-container *transloco="let t">
      <div
        class="px-2 border rounded-full text-center"
        [class]="stateClass()"
      >
        {{ t(label()) }}
      </div>
    </ng-container>
  `,
})
export class PriorityIndicatorComponent {
  protected readonly STATE_CLASSES: Record<Priority, string> = {
    high: 'border-red-3 bg-red-2 text-red-8',
    medium: 'border-orange-4 bg-orange-2 text-orange-8',
    low: 'border-yellow-5 bg-yellow-2 text-yellow-9',
  };
  protected readonly STATE_TRANSLATION_KEYS: Record<Priority, string> = {
    high: 'PRIORITY.HIGH',
    medium: 'PRIORITY.MEDIUM',
    low: 'PRIORITY.LOW',
  };

  priority = input.required<Priority>();

  stateClass = computed(() => this.getStateClass(this.priority()));
  label = computed(() => this.getStateTranslationKey(this.priority()));

  getStateClass(priority: Priority) {
    return this.STATE_CLASSES[priority];
  }
  getStateTranslationKey(priority: Priority) {
    return this.STATE_TRANSLATION_KEYS[priority];
  }
}
